import React from "react";
import classes from "./Layout.module.css";
import Modal from "../../../components/Modal/Modal";

const Layout = (props) => {
  return (
    <div className={classes.Layout}>
      <div className={classes.Layout_wrapper}>{props.children}</div>
      <Modal />
    </div>
  );
};

export default Layout;
